import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomerAccountItem } from '@inyova/models';

@Component({
  selector: 'app-profile-i4k-row',
  templateUrl: './profile-i4k-row.component.html',
  styleUrls: ['./profile-i4k-row.component.scss'],
  standalone: false
})
export class ProfileI4kRowComponent {
  @Input() kidAccount: CustomerAccountItem;
  @Output() editName: EventEmitter<CustomerAccountItem> = new EventEmitter<CustomerAccountItem>();

  onEditName(kidAccount: CustomerAccountItem) {
    this.editName.emit(kidAccount);
  }
}
